import Handsontable from 'handsontable'

/**
 * Official plugin to enable removing rows.
 */
export default function () {
    const eventManager = new Handsontable.EventManager(this);

    const checkRowHeader = function (element) {
        if (element.tagName !== 'BODY') {
            if (element.parentNode.tagName === 'TBODY') {
                return true;
            } else {
                element = element.parentNode;

                return checkRowHeader(element);
            }
        }

        return false;
    };
    const getElementFromTargetElement = function (element) {
        if (element.tagName !== 'TABLE') {
            if (element.tagName === 'TH' || element.tagName === 'TD') {
                return element;
            } else {
                return getElementFromTargetElement(element.parentNode);
            }
        }

        return null;
    };

    function bindMouseEvents() {
        const instance = this;

        eventManager.addEventListener(instance.rootElement, 'mouseover', function (e) {
            if (checkRowHeader(e.target)) {
                const element = getElementFromTargetElement(e.target);

                if (element) {
                    const btn = getButton(element);

                    if (btn) {
                        btn.style.display = 'block';
                    }
                }
            }
        });

        eventManager.addEventListener(instance.rootElement, 'mouseout', function (e) {
            if (checkRowHeader(e.target)) {
                const element = getElementFromTargetElement(e.target);

                if (element) {
                    const btn = getButton(element);

                    if (btn) {
                        btn.style.display = 'none';
                    }
                }
            }
        });
    }

    function unbindMouseEvents() {
        eventManager.clear();
    }

    function getButton(td) {
        let btn = td.querySelector('.removeRowBtn');

        if (!btn) {
            const parent = td.parentNode.querySelector('th.htRemoveRow');

            if (parent) {
                btn = parent.querySelector('.removeRowBtn');
            }
        }

        return btn;
    }

    this.init = function (instance) {
        const pluginEnabled = !!(instance.getSettings().removeRowPlugin);

        if (pluginEnabled) {
            bindMouseEvents.call(instance);
            Handsontable.dom.addClass(instance.rootElement, 'htRemoveRow');
        } else {
            unbindMouseEvents.call(instance);
            Handsontable.dom.removeClass(instance.rootElement, 'htRemoveRow');
        }
    };

    this.beforeInitWalkontable = function (instance, walkontableConfig) {
        /**
         * rowHeaders is a function, so to alter the actual value we need to alter the result returned by this function
         */
        const baseRowHeaders = walkontableConfig.rowHeaders;
        walkontableConfig.rowHeaders = function () {
            const pluginEnabled = !!(instance.getSettings().removeRowPlugin);

            const newRowHeader = function (row, elem) {
                let child, div, button;

                while (child = elem.lastChild) {
                    elem.removeChild(child);
                }
                elem.className = 'htNoFrame htRemoveRow';

                if (row > -1) {
                    div = document.createElement('div');
                    div.className = 'removeRowBtn';
                    button = document.createElement('i');
                    button.className = "fa fa-remove";
                    div.appendChild(button);
                    elem.appendChild(div);

                    eventManager.addEventListener(div, 'mouseup', function () {
                        instance.alter('remove_row', row);
                    });
                }
            };

            return pluginEnabled ? Array.prototype.concat.call([], newRowHeader, baseRowHeaders()) : baseRowHeaders();
        };
    }
}


// WEBPACK FOOTER //
// ./App/components/Handsontable/plugins/removeRowplugin.js